import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message } from 'semantic-ui-react'
import DropzoneComponent from 'react-dropzone-component';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import '../../../../node_modules/react-dropzone-component/styles/filepicker.css';
import '../../../../node_modules/dropzone/dist/min/dropzone.min.css';

import FormsInputsText from '../inputs/text/forms_inputs_text';
import FormsInputDate from '../inputs/date';
import FormsInputDropdown from '../inputs/dropdown';
// import FormsInputsRadioGroup from '../../inputs/radio';
import FormsInputsRadioGroupDynamic from '../inputs/radiodynamic';
import FormsInputsDropdownAddition from '../inputs/dropdownaddition';
// import FormsInputsSingleCheckbox from '../inputs/singlecheckbox';
// import FormsInputsTime from '../../inputs/time';
import ElogSchema from './validation';
import { djsConfig } from '../../../template/DropZoneTemplate';

import {
    getQnsInitialValues,
    getQnsFormikForm
} from '../../../utils/elog_form_helper';

const yesNoOptions = [
    { text: 'Yes', value: 'Y' },
    { text: 'No', value: 'N'}
];
const genderOptions = [
    { text: 'Male', value: 'Male' },
    { text: 'Female', value: 'Female' },
];
const maritalStatusOptions = [
    { text: 'Single', value: 'Single' },
    { text: 'Married', value: 'Married' },
    { text: 'Divorced', value: 'Divorced' },
    { text: 'Widowed', value: 'Widowed' },
];
const nationalityOptions = [
    { text: 'American', value: 'American' },
    { text: 'Australian', value: 'Australian' },
    { text: 'Burmese', value: 'Burmese' },
    { text: 'British', value: 'British' },
    { text: 'Chinese', value: 'Chinese' },
    { text: 'Filipinos', value: 'Filipinos' },
    { text: 'Indonesian', value: 'Indonesian' },
    { text: 'Malaysian', value: 'Malaysian' },
    { text: 'Singaporean', value: 'Singaporean' },
];
const prepareRadioSelection = (list) => {
    return _.map(list, (data) => {
        return { label: data.name, value: data.nric };
    })
};

const prepareDynamicDropDownSelectionCompany = (list, useValueAsText = false) => {
    const sortedCompaniesList = _.filter(list, (company) => company.memberType.toUpperCase() == 'E');
    return _.map(sortedCompaniesList, (item) => {
        return { text: (useValueAsText === false) ? item.companyName : item.companyId , value: item.companyId };
    })
};

const prepareDynamicDropDownSelectionPatient = (list, selectedCompany) => {
    const selectedList = list.filter( company => company.companyId === selectedCompany.companyId);

    if (selectedList[0]) 
    {
        return selectedList[0].records.map( item => {
            return { text: item.name, value: item.nric }
        })
    } else {
            return []
    }
};

const prepareDynamicDropDownSelectionHospital = (list, useValueAsText = false) => {
    const sortedList = _.sortBy(list, 'n')
    return _.map(sortedList, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: item.n };
    })
};

const prepareDynamicDropDownSelection = (list, useValueAsText = false, useTextAsValue = false) => {
    return _.map(list, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

var componentConfig = {
    iconFiletypes: ['.jpeg', '.jpg', '.png', '.pdf'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
};
// var djsConfig = {
//     autoProcessQueue: false,
//     addRemoveLinks: true
// }

class FormsElog extends Component {
    state = {
        files: [],
        error: false,
        errorMessage: null,
        success: false,
        successMessage: null,
        eLogId: null,
        numberOfCheckBox: 0,
        checkBoxErrorMessageShow: false,
        checkBoxErrorMessage: null,
        loading: false,
    }

    componentDidMount(){
        let updatedElogQuestionObject = Object.assign({}, this.props.eLogQuestions[0]);
        const { questions } = updatedElogQuestionObject;
        const { claimOptions } = this.props;
        const { accessToken } = this.props.user;

        // validate if all choices are checked which by default is undefined
        for (let i = 0; i < questions.length; i++) {
            const question = questions[i];
            const { id, type, inputs, choices, title, error } = question;
            if (type === 'multiple_with_input_sub') {
                const _numberOfCheckBox = choices.length
                this.setState({
                    numberOfCheckBox: _numberOfCheckBox,
                    checkBoxErrorMessage: error
                })
            }
        }

        if (!claimOptions.inpatientClaimOptions || !claimOptions.outpatientClaimOptions) {
            this.props.getClaimOptions(accessToken);
        }
    }

    updateFileTest(file) {
        this.setState({files: [...this.state.files, file]});
    }

    removeFile(file) { 
        this.setState({
            files: this.state.files.filter(f => f !== file),
            error:false,
            errorMessage:''});
    }
    renderClaimSubmissionResult() {
        // if (this.state.success === true) {
        //     return (
        //         <Message positive>
        //             <Message.Header>Elog {this.state.eLogId} Created Successfully!</Message.Header>
        //             <p>
        //                 {this.state.successMessage}
        //             </p>
        //             <p>
        //                 <Link to="/app/elogrecords">
        //                     Click here to view your Elog records now!
        //                 </Link>
        //             </p>
        //         </Message>
        //     );
        // }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the elog submission.</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                    <p>
                        <Link to="/app/askjoey">
                            <Button>
                                Ask Joey
                            </Button>
                        </Link>
                    </p>
                </Message>
            );
        }
    }
    checkAttachmentFile() {
        if (this.state.files.find( (file) => file.size >= 5242880)) {
            return (
                <Message negative>
                    <p>
                        { 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.' }
                    </p>
                </Message>
            );
        }
    }
    render() {
        const qnsInitialValues = getQnsInitialValues(this.props.eLogQuestions[0].questions);
        // console.log('qnsInitialValues', qnsInitialValues);
        const { dl } = this.props.claimOptions.outpatientClaimOptions ? this.props.claimOptions.outpatientClaimOptions : {};
        const { hl, il } = this.props.claimOptions.inpatientClaimOptions ? this.props.claimOptions.inpatientClaimOptions : {};

        var _numberOfCheckBox = 0 // use to count the number of checkbox checked

        return (
            <div>
                {
                    this.state.success
                    &&
                    <Message positive>
                        <Message.Header>Elog {this.state.eLogId} Created Successfully!</Message.Header>
                        <p>
                            {this.state.successMessage}
                        </p>
                        <p>
                            <Link to="/app/elogrecords">
                                Click here to view your Elog records now!
                            </Link>
                        </p>
                        <p>
                            <Link to={`/app/askjoey?type=elog&id=${encodeURIComponent(this.state.eLogId)}`}>
                                <Button>
                                    Ask Joey
                                </Button>
                            </Link>
                        </p>
                    </Message>
                }
                {
                    !this.state.success
                    &&
                    <Formik
                        initialValues={Object.assign({}, {
                            companyId: this.props.user.companies[0].companyId,
                            nric: '',
                            hospital: '',
                            diagnosis: '',
                            descriptionOfSymptoms: '',
                            dateTheSymptomsStarted: moment(),
                            dateFrom: moment(),
                            doctorName: ''
                        }, qnsInitialValues)}
                        validationSchema={ElogSchema}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validate={(values) => {
                            this.setState({
                                checkBoxErrorMessageShow: false
                            })

                            // Additional Validation (if any)
                            let error = {};

                            if (this.props.eLogQuestions[0].attachments && this.props.eLogQuestions[0].attachments.optional === false) {
                                if (this.state.files.length === 0) {
                                    error.uploadAttachments = 'No Files Uploaded.';
                                }
                            }
                            // if (this.state.files.length > 100) {
                            //     error.uploadAttachments = 'Only a maximum of 100 files can be uploaded';
                            // }
                            if (this.state.files.find( (file) => file.size >= 5242880 )) {
                                error.maxFilesize = 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.';
                            }
                            let updatedElogQuestionObject = Object.assign({}, this.props.eLogQuestions[0]);
                            const { questions } = updatedElogQuestionObject;
                            for (const valueKey in values) {
                                if (values.hasOwnProperty(valueKey)) {
                                    if (valueKey.indexOf('qns--') !== -1) {
                                        const qnsIdArray = valueKey.split('--');
                                        const sectionId = qnsIdArray[1];
                                        const inputType = qnsIdArray[2];
                                        const choiceIndex = qnsIdArray[3];
                                        const inputValue = values[valueKey];
                                        const selectedSection = _.find(questions, (question) => question.id === sectionId);
                                        if (inputType === 'multiple_with_input_sub') {
                                            // ignore as value is always true or false
                                            // selectedSection.choices[choiceIndex].checked = inputValue;
                                            _numberOfCheckBox = _numberOfCheckBox + 1
                                        }
                                        else {
                                            if (typeof selectedSection.inputs[choiceIndex].optional === 'boolean' && selectedSection.inputs[choiceIndex].optional === false) {
                                                if (!inputValue || inputValue.toString().trim() === '') {
                                                    if (inputValue.toString().trim() !== "0") {
                                                        error[valueKey] = 'Field is Mandatory';
                                                    }
                                                }
                                            }
                                            if (selectedSection.inputs[choiceIndex].type === 'input_number') {
                                                if (inputValue && inputValue.toString().trim() !== '') {
                                                    // check value is a number
                                                    if (isNaN(inputValue)) {
                                                        error[valueKey] = 'Input must be a valid number';
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }

                            if (_numberOfCheckBox < this.state.numberOfCheckBox){
                                this.setState({
                                    error: false,
                                    errorMessage: null,
                                    success: false,
                                    successMessage: null,
                                    eLogId: null,
                                    checkBoxErrorMessageShow: true,
                                    loading: false
                                });
                            }

                            // console.log(error);

                            return error;
                        }}
                        onSubmit={(values, actions) => {
                            console.log('values-values', values);
                            this.setState({
                                error: false,
                                errorMessage: null,
                                success: false,
                                successMessage: null,
                                eLogId: null,
                                loading: true
                            });
                            // console.log(values, actions);
                            // update eLogQuestions Object
                            let updatedElogQuestionObject = Object.assign({}, this.props.eLogQuestions[0]);
                            const { questions } = updatedElogQuestionObject;

                            if (this.state.checkBoxErrorMessageShow){
                                this.setState({
                                    error: false,
                                    errorMessage: null,
                                    success: false,
                                    successMessage: null,
                                    eLogId: null,
                                    loading: false
                                });
                                return
                            }

                            for (const valueKey in values) {
                                if (values.hasOwnProperty(valueKey)) {
                                    if (valueKey.indexOf('qns--') !== -1) {
                                        const qnsIdArray = valueKey.split('--');
                                        const sectionId = qnsIdArray[1];
                                        const inputType = qnsIdArray[2];
                                        const choiceIndex = qnsIdArray[3];
                                        const inputValue = values[valueKey];
                                        const selectedSection = _.find(questions, (question) => question.id === sectionId);
                                        if (inputType === 'multiple_with_input_sub') {
                                            selectedSection.choices[choiceIndex].checked = inputValue;
                                        } else {
                                            selectedSection.inputs[choiceIndex].value = inputValue;
                                        }
                                    }
                                }
                            }
                            values = _.pick(values, ['companyId','nric','hospital','diagnosis','descriptionOfSymptoms','dateTheSymptomsStarted','dateFrom','doctorName']);
                            values.patientName = this.props.user.name;
                            values.email = this.props.user.email;
                            values.insurer = 'income';
                            values.questionnaire = JSON.stringify(updatedElogQuestionObject);
                            values.dateFrom = moment(values.dateFrom).format('YYYY-MM-DD');
                            values.dateTheSymptomsStarted = moment(values.dateTheSymptomsStarted).format('YYYY-MM-DD');
                            // console.log('values', values);

                            const {accessToken} = this.props.user;

                            this.props.submitElog({data: values, attachments: this.state.files, accessToken}, (result, error) => {
                                if (result) {
                                    this.setState({
                                        error: false,
                                        errorMessage: null,
                                        success: true,
                                        successMessage: result.success_message,
                                        eLogId: result.eLoG_id,
                                        loading: false
                                    });
                                }
                                if (error) {
                                    this.setState({
                                        error: true,
                                        errorMessage: error.errorMessage,
                                        success: false,
                                        successMessage: null,
                                        eLogId: null,
                                        loading: false
                                    });
                                    actions.setSubmitting(false);
                                }
                            })

                        }}
                        render={({
                            values,
                            errors,
                            status,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                            <Form style={{paddingBottom: 20}}>
                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        {/* <Divider horizontal>
                                            eLOG Information
                                        </Divider> */}
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Message warning>
                                            <p>
                                                LOG is valid for 30 days from the date of issuance. If admission date is more than 30 days from today, please submit request on a later date prior to the admission.
                                            </p>
                                        </Message>
                                    </Grid.Column>
                                    {/* <Grid.Column width={16}>
                                        <Field
                                            name="nric"
                                            label="Select Patient"
                                            component={FormsInputsRadioGroupDynamic}
                                            secondaryLabel=""
                                            choices={prepareRadioSelection(this.props.user.records)}
                                        />
                                    </Grid.Column> */}
                                    {this.props.user.companies.length > 1 &&
                                    <Grid.Column>
                                        <Field
                                            name="companyId"
                                            label="Select Company"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionCompany(this.props.user.companies)}
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>}
                                    <Grid.Column>
                                        <Field
                                            name="nric"
                                            label="Select Patient"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionPatient(this.props.user.companies, _.pick(values,['companyId']))}
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="hospital"
                                            label="Hospital"
                                            options={prepareDynamicDropDownSelectionHospital(hl)}
                                            component={FormsInputDropdown}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="diagnosis"
                                            label="Diagnosis / Medical Condition"
                                            options={prepareDynamicDropDownSelection(dl, false, true)}
                                            component={FormsInputsDropdownAddition}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="descriptionOfSymptoms"
                                            label="Description of Symptoms"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="dateTheSymptomsStarted"
                                            component={FormsInputDate}
                                            label="Date the Symptoms Started"
                                            secondaryLabel=""
                                            maxDate={moment()}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="dateFrom"
                                            component={FormsInputDate}
                                            label="Admission Date"
                                            secondaryLabel=""
                                            minDate={moment()}
                                            maxDate={moment().add(30, 'days')}
                                        />
                                    </Grid.Column>
                                    {/*
                                        <Grid.Column>
                                            <Field
                                                name="doctorName"
                                                label="Name of Doctor"
                                                component={FormsInputsText}
                                                secondaryLabel=""
                                            />
                                        </Grid.Column>
                                    */}

                                    { getQnsFormikForm(this.props.eLogQuestions[0].questions) }

                                    <Grid.Column width={16}>
                                        {
                                            this.state.checkBoxErrorMessageShow === true
                                            &&
                                            <Message negative>
                                                <p>
                                                    { this.state.checkBoxErrorMessage }
                                                </p>
                                            </Message>
                                        }
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        You may upload more than 1 documents:
                                        <DropzoneComponent
                                            config={componentConfig}
                                            eventHandlers={
                                                {
                                                    addedfile: (file) => {
                                                        // console.log(file);
                                                        if (file.type.includes('jpeg')||
                                                            file.type.includes('jpg')||
                                                            file.type.includes('png')||
                                                            file.type.includes('pdf')||
                                                            file.type.includes('heif')||
                                                            file.type.includes('heic')){
                                                                this.updateFileTest(file);
                                                            } else {
                                                                this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                            }
                                                    },
                                                    removedfile: (file) => {
                                                        this.removeFile(file);
                                                    }
                                                }
                                            }
                                            djsConfig={djsConfig}
                                        />
                                        {this.checkAttachmentFile()}
                                        {
                                            (errors['uploadAttachments']) &&
                                            (
                                                <Message negative>
                                                    {errors['uploadAttachments']}
                                                </Message>
                                            )
                                        }
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        {this.renderClaimSubmissionResult()}
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Button
                                            loading={this.state.loading}
                                            type="submit"
                                            primary
                                            disabled={this.state.loading}
                                            fluid
                                            size="big"
                                        >
                                            Request Elog
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        )}
                    />
                }
            </div>
        );
    }
}

export default FormsElog;
